import { Injectable } from '@angular/core';
import { TableService } from './table-service';

@Injectable({
  providedIn: 'root'
})
export class VisitService extends TableService {

  override baseUrl = '/visits';

  override multilpleFilterBaseUrl = "/multiplevisits";
  
  override downloadPOSUrl = "/getpos";
}
